import Fingerprint2 from 'fingerprintjs2';

export const getFingerprint = () =>
  new Promise((resolve) => {
    setTimeout(() => {
      Fingerprint2.get((components) => {
        const values = components.map((component) => component.value);
        const murmur = Fingerprint2.x64hash128(values.join(''), 31);
        resolve({
          hash: murmur,
          components,
        });
      });
    }, 500);
  });
